import { Check } from "lucide-react";

export interface RegisteredTickProps {
  /** Whether the person holds a registered membership in the season shown. */
  registered: boolean;
}

/**
 * The „Registrovaný" mark: a tick for a registered member, nothing for a
 * nečlen.
 *
 * A badge said the same thing twice over — every roster row carried a
 * coloured chip, and a column whose value is „Člen" on nearly every line
 * is a column of noise. The entry wizard's competitor picker already
 * answered this with a tick, so the rest of the app follows it: the eye
 * finds the gaps, which is what anyone reading a soupiska is looking for.
 *
 * Deliberately renders NOTHING for a guest rather than a cross or a dash.
 * A nečlen is a legitimate entrant at a pohárovka, not an error state, and
 * the absent tick is the whole statement.
 */
export function RegisteredTick({ registered }: RegisteredTickProps) {
  if (!registered) return null;
  return <Check size={16} aria-label="Registrovaný" />;
}
